export default "__VITE_ASSET__CRG12LmM__"